import { WalletMfaVerificationPhase, WalletMfaVerificationPurpose } from './wallet-mfa-types';

export type WalletMfaVerificationState = {
  phase: WalletMfaVerificationPhase;
  code: string;
  error: string | null;
  purpose: WalletMfaVerificationPurpose;
};

export const VERIFICATION_IDLE_TIMEOUT_MS = 300_000;
export const RESTART_AFTER_TIMEOUT =
  'Confirmation expired. Restart the wallet action to try again.';
export const RESTART_AFTER_MAX_ATTEMPTS =
  'Too many attempts. Restart the wallet action to try again.';
export const RESTART_AFTER_CONCURRENT_REQUEST =
  'Another wallet action requested confirmation. Restart both wallet actions and try again.';

export const createVerificationState = (
  phase: WalletMfaVerificationPhase,
  purpose: WalletMfaVerificationPurpose,
  { error = null }: { error?: string | null } = {},
): WalletMfaVerificationState => ({
  phase,
  code: '',
  error,
  purpose,
});

export const createClosedVerificationState = (): WalletMfaVerificationState =>
  createVerificationState(
    WalletMfaVerificationPhase.Closed,
    WalletMfaVerificationPurpose.Transaction,
  );
